import { all, call, fork, put, takeLatest, select } from "redux-saga/effects";
import InvoicesActions, { InvoicesTypes } from '../redux/Invoices';
import MessageActions from "../redux/Messages";
import AuthActions from "../redux/Auth";
import UserActions from "../redux/User";
import { 
  getInvoicesRequest,
  addInvoiceRequest,
} from "../services/Invoices";

function* getInvoices() {
  try {
    yield put(AuthActions.showAuthLoader())
    const { user: { id } } = yield select(state => state.user);
    const invoices = yield call(getInvoicesRequest, id);
    yield put(AuthActions.hideAuthLoader())
    yield put(InvoicesActions.getInvoicesDone(invoices))
  } catch (error) {
    yield put(InvoicesActions.getInvoicesError(error))
  }
}

function* addInvoice({ userId, form }) {
  yield put(AuthActions.showAuthLoader())
  yield call(addInvoiceRequest, userId, form);
  yield put(AuthActions.hideAuthLoader());
  yield put(MessageActions.showMessage('Orden creada con exito', false));
  yield put(MessageActions.hideMessage());
}

export function* getInvoicesWatcher() {
  yield takeLatest(InvoicesTypes.GET_INVOICES, getInvoices);
}

export function* addInvoiceWatcher() {
  yield takeLatest(InvoicesTypes.ADD_INVOICE, addInvoice);
}

export default function* rootSaga() {
  yield all([
    fork(getInvoicesWatcher),
    fork(addInvoiceWatcher),
  ]);
}